(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Desktop mega menu — hover intent */
  var navItems = document.querySelectorAll('[data-nav-item]');
  navItems.forEach(function (item) {
    var closeTimeout;

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimeout);
      navItems.forEach(function (i) { i.removeAttribute('data-open'); });
      item.setAttribute('data-open', '');
    });

    item.addEventListener('mouseleave', function () {
      closeTimeout = setTimeout(function () {
        item.removeAttribute('data-open');
      }, 120);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      navItems.forEach(function (i) { i.removeAttribute('data-open'); });
    }
  });

  /* Mobile accordion */
  document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mobile-nav__item');
      var children = item ? item.querySelector('.mobile-nav__children') : null;
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      /* Collapse all other open items */
      document.querySelectorAll('[data-mobile-toggle][aria-expanded="true"]').forEach(function (other) {
        if (other === btn) return;
        other.setAttribute('aria-expanded', 'false');
        var otherItem = other.closest('.mobile-nav__item');
        var otherChildren = otherItem ? otherItem.querySelector('.mobile-nav__children') : null;
        if (otherChildren) otherChildren.setAttribute('aria-hidden', 'true');
      });

      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (children) children.setAttribute('aria-hidden', expanded ? 'true' : 'false');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-variant-json]');
    var selects = root.querySelectorAll('[data-variant-selector]');
    if (!jsonEl || selects.length === 0) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabel = root.querySelector('[data-add-label]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) {
          return o === chosen[i];
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) {
          addLabel.textContent = match.available
            ? (addBtn.dataset.labelAdd || 'Add to cart')
            : (addBtn.dataset.labelSoldout || 'Sold out');
        }
      }
    }

    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', update);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
